import { Box } from "@mui/material";
import Recommended from "../../../src/assets/images/leads.svg";
import Button from '@mui/material/Button';
import DataGridDemo from "../../components/doctor/LeadsTable"; 
import React from 'react';


function DoctorMain() {
  return (
    <Box>

      <div className="main-div">
        <div className="main-card">
          <div className="wrapper-card-heading">

            <h4 className="main-content-heading-col">Leads Updates</h4>

          </div>
          <div className="leads-card-row">
            <div className="total-cards-col card-light-blue">

              <span className="img-bg-card-wrapper span-primary">
                <img src={Recommended} className="img-fluid" alt="recommended-leads" />
              </span>

              <h3>100</h3>
              <p>Total Leads Recommend</p>
            </div>

            <div className="total-cards-col card-light-green">

              <span className="img-bg-card-wrapper  span-green">
                <img src={Recommended} className="img-fluid" alt="recommended-leads" />
              </span>

              <h3>70</h3>
              <p>Total Leads Converted</p>
            </div>

            <div className="total-cards-col card-light-yellow">

              <span className="img-bg-card-wrapper span-peach">
                <img src={Recommended} className="img-fluid" alt="recommended-leads" />
              </span>

              <h3>5</h3>
              <p>Leads Generated Today</p>
            </div>

            <div className="total-cards-col card-light-peach">

              <span className="img-bg-card-wrapper span-dark-peach">
                <img src={Recommended} className="img-fluid" alt="recommended-leads" />
              </span>

              <h3>30</h3>
              <p>Unconverted Leads</p>
            </div>

          </div>

        </div>



      <section className="admin-table-section">
      <div className="main-card table-card-wrapper">
         <div className="table-heading-row">
          <div>
          <h4> Recent 5 lead</h4>
          <p>Sales Summery</p>
          </div>

          <div>
          <Button variant="contained">VIEW ALL</Button>
          </div>
         </div>

         <div>
          <DataGridDemo />          
         </div>
         
        </div>
      </section>

      </div>

    </Box>
  );
}


export default DoctorMain;